import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

import './scss/app-alert.scss';
import Color from '@/tool/color';
import AppPortal from './app-portal';

interface IProps {
  text: string,
}
interface IState {}

const AppAlert = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const { text } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <AppPortal>
      <section className="app-alert">
        <p className="text-500">{text}</p>
      </section>
    </AppPortal>
  );
};

export default observer(AppAlert);
